import { render } from "./Faculties.vue?vue&type=template&id=529e7a20&scoped=true"
import script from "./Faculties.vue?vue&type=script&lang=js"
export * from "./Faculties.vue?vue&type=script&lang=js"

import "./Faculties.vue?vue&type=style&index=0&id=529e7a20&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-529e7a20"

export default script